import { BaseService, Service } from "/@/cool";
@Service("groupRepairReject")
class GroupRepairReject extends BaseService {
    constructor() {
        super();

        let prefix = "";
        if (this.namespace) {
            prefix = this.namespace.replace(/\//g, ":") + ":";
        }

        this.permission["page"] = prefix + "page";
        this.permission["rejectPage"] = prefix + "rejectPage";
    }
    async rejectPage(data: any) {
        return this.request({
            url: "/rejectPage",
            method: "post",
            data
        });
    }
}
export default GroupRepairReject;
